import React from "react";
import { FaRegClock } from "react-icons/fa";
import { Row, Col, Card, Button, Image, Badge } from "react-bootstrap";
import { FaAddressBook } from "react-icons/fa";
import ulefone from "../../assets/img/vendors/ulefone.png";
import huawei from "../../assets/img/vendors/huawei.png";
import hvezda from "../../assets/img/favicon.png";
import { Markup } from "react-render-markup";

class Contacts extends React.Component {
  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaAddressBook className="c-placeholder c-green" />,
      Title: "Kontakty",
      SubTitle: "Jak se k nám dovoláte nebo dostanete",
    });
    var stred = window.SMap.Coords.fromWGS84(14.1177133, 50.1252781);
    var mapa = new window.SMap(window.JAK.gel("mapa"), stred, 10);
    mapa.addDefaultLayer(window.SMap.DEF_BASE).enable();
    mapa.addDefaultControls();

    var layer = new window.SMap.Layer.Marker();
    mapa.addLayer(layer);
    layer.enable();

    var options = {};
    var marker = new window.SMap.Marker(stred, "myMarker", options);
    layer.addMarker(marker);
  }

  render() {
    return (
      <>
        <Row>
          <Col
            xs={4}
            className="d-flex justify-content-start align-items-center"
          >
            <Row>
              <Col
                xs={12}
                className="d-flex justify-content-start align-items-center mb-4"
              >
                <h5>BRITEX-CZ</h5>
              </Col>
              <Col
                xs={12}
                className="d-flex justify-content-start align-items-center"
              >
                <a href="tel:+420312242415">+420 312 242 415-9</a>
              </Col>
              <Col
                xs={12}
                className="d-flex justify-content-start align-items-center mb-4"
              >
                <a href="mailto:mobil@britex.cz?Subject=Zpráva z webu">
                  mobil@britex.cz
                </a>
              </Col>
              <Col
                xs={12}
                className="d-flex justify-content-start align-items-center"
              >
                <p>
                  MIlady Horákové 125 <br /> Kladno, 272 01 CZ
                </p>
              </Col>
              <Col
                xs={12}
                className="d-flex justify-content-start align-items-center"
              >
                <p>
                  Otevírací doba:<br /> 8.00-16.30 Po-Pá <br /> Přestávka: 13.00-13.30
                </p>
              </Col>
            </Row>
          </Col>
          <Col xs={8} className="d-flex justify-content-end">
            <div id="mapa" style={{ width: "700px", height: "400px" }} />
          </Col>
        </Row>
      </>
    );
  }
}

export default Contacts;
